import { html, LitElement } from 'lit';
import { connect } from 'pwa-helpers/connect-mixin.js';
import menuService from '../services/menu.service.js';
import { store } from '../store.js';


export class MenuElement extends connect(store)(LitElement) {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  renderMenuItems(itemGroup){
    const menuItems = [...menuService.activeMenuItems(itemGroup)].sort((item1, item2) => item1.displayOrderInGroup - item2.displayOrderInGroup);
    return menuItems?.map(this.renderMenuItem)??html``;
  }
}

